import React from 'react';
import {
  Fab,
  Tooltip,
  Box,
  Typography,
  Chip
} from '@mui/material';
import {
  Security as SecurityIcon,
  LockOpen as LockOpenIcon,
  Lock as LockIcon
} from '@mui/icons-material';
import { useBypass } from '../contexts/BypassContext';

const PaywallBypassToggle = () => {
  const { bypassEnabled, loading, isDevelopment, toggleBypass } = useBypass();

  // Don't render in production
  if (!isDevelopment) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1
      }}
    >
      {/* Status Chip */}
      <Chip
        icon={bypassEnabled ? <LockOpenIcon /> : <LockIcon />}
        label={bypassEnabled ? 'Paywalls OFF' : 'Paywalls ON'}
        color={bypassEnabled ? 'success' : 'default'}
        variant="outlined"
        size="small"
        sx={{
          backgroundColor: bypassEnabled ? 'rgba(76, 175, 80, 0.1)' : 'rgba(158, 158, 158, 0.1)',
          borderColor: bypassEnabled ? 'rgba(76, 175, 80, 0.3)' : 'rgba(158, 158, 158, 0.3)',
          color: bypassEnabled ? '#4caf50' : '#9e9e9e',
          fontWeight: 'bold',
          fontSize: '0.75rem'
        }}
      />

      {/* Toggle Button */}
      <Tooltip 
        title={bypassEnabled ? 'Disable paywall bypass' : 'Enable paywall bypass'}
        placement="left"
      >
        <Fab
          color={bypassEnabled ? 'success' : 'default'}
          size="medium"
          onClick={toggleBypass}
          disabled={loading}
          sx={{
            backgroundColor: bypassEnabled ? '#4caf50' : '#f5f5f5',
            color: bypassEnabled ? 'white' : '#666',
            '&:hover': {
              backgroundColor: bypassEnabled ? '#45a049' : '#e0e0e0',
            },
            '&:disabled': {
              backgroundColor: '#e0e0e0',
              color: '#9e9e9e'
            },
            transition: 'all 0.3s ease',
            boxShadow: bypassEnabled 
              ? '0 4px 12px rgba(76, 175, 80, 0.3)' 
              : '0 2px 8px rgba(0, 0, 0, 0.1)'
          }}
        >
          {bypassEnabled ? <LockOpenIcon /> : <SecurityIcon />}
        </Fab>
      </Tooltip>

      {/* Development Label */}
      <Typography
        variant="caption"
        sx={{
          color: '#666',
          fontSize: '0.65rem',
          textAlign: 'center',
          maxWidth: 80,
          lineHeight: 1.2
        }}
      >
        DEV MODE
      </Typography>
    </Box>
  );
};

export default PaywallBypassToggle;
